"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transform = transform;
function transform(actions) {
    if (actions instanceof Array) {
        return actions.map(function (action) {
            return action.type;
        });
    } else {
        return actions.type;
    }
}
//# sourceMappingURL=transform.js.map


// WEBPACK FOOTER //
// ./node_modules/@zaibot/fsa-saga/es5/transform.js